export default "__VITE_ASSET__D0B_FUeJ__"